import React from "react";
import HeroSection from "./HeroSection";
import AboutUs from "./AboutUs";
import Services from "./Services";
import HeroCarousel from "./HeroCarousel";
import WhyChooseInfronex from "./WhyChooseInfronex";
import HomeCTA from "./HomeCTA";

export default function Home() {
  return (
    <div>
      <HeroCarousel/>
      {/* <HeroSection /> */}
      <AboutUs/>
      <Services/>
      <WhyChooseInfronex/>
      <HomeCTA/>
      
    </div>
  );
}
